export default __webpack_public_path__ + "static/media/people.fd529e6b.csv";